var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePop',{attrs:{"title":_vm.$t('select_server_role')}},[_c('div',{staticClass:"tip-orange"},[_vm._v(_vm._s(_vm.$t('please_select_regionrole')))]),_c('ServerRole')],1)}
var staticRenderFns = []

export { render, staticRenderFns }